import { EventManager } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ResizeService {
  private eventManager = inject(EventManager);

  get onResize$(): Observable<Window> {
    return this.resizeSubject.asObservable();
  }

  private resizeSubject: Subject<Window>;

  constructor() {
    this.resizeSubject = new Subject();
    window.addEventListener('resize', this.onResize.bind(this));
  }

  private onResize(event: UIEvent) {
    this.resizeSubject.next(<Window>event.target);
  }
}
